
export default {
  name: 'RelatedArticles',
  props: {
    pages: {
      type: Object,
      require: true,
    },
  },
  methods: {
    makeTitle(slug) {
      const parts = slug.split('/');
      const words = parts.at(-1).split('-')
      return words
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
        })
        .join(' ')
    },
  },
}
